import { type ReactNode, useState } from 'react';
import { useAuth } from '@/hooks/use-auth';
import { useProgressSummary } from '@/hooks/use-progress-summary';
import { useLeaderboard } from '../hooks/use-leaderboard';
import type { TimePeriod } from '../types';
import { CreatorsProgressSection } from './creators-progress-section';
import { CreatorsDistributionSection } from './creators-distribution-section';
import { ProgressOverview } from './progress-overview';
import { TimePeriodSelector } from './time-period-selector';
import { LeaderboardTable } from './leaderboard-table';

function useInvestmentSummary(): { total: number; goal: number } | undefined {
  const { data } = useProgressSummary();
  if (!data) return undefined;
  return { total: data.total_invested, goal: data.total_investment_goal };
}

export function ProgressPage(): ReactNode {
  const { isAdmin } = useAuth();
  const [period, setPeriod] = useState<TimePeriod>(isAdmin ? 'month' : 'week');
  const { data, isLoading } = useLeaderboard(period);
  const investment = useInvestmentSummary();
  return (
    <div className="space-y-lg">
      <CreatorsProgressSection />
      <ProgressOverview />
      <CreatorsDistributionSection />
      <div className="flex items-center justify-between">
        <p className="text-[11px] font-medium uppercase tracking-wider text-text-tertiary/50">
          Leaderboard
        </p>
        {isAdmin && <TimePeriodSelector value={period} onChange={setPeriod} />}
      </div>
      <LeaderboardTable
        data={data}
        isLoading={isLoading}
        investment={investment}
      />
    </div>
  );
}
